<!--
 * @Author: xiejun jun.xie@gtechhdigi.com
 * @Date: 2024-09-06 17:02:41
 * @LastEditors: xiejun jun.xie@gtechhdigi.com
 * @LastEditTime: 2024-10-30 19:12:04
 * @FilePath: /ua-cnbs-mall/src/pages/pdp/components/FillBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import CCVideo from '@/components/Video/VideoPlayerE.vue';
import URLVideo from '@/components/Video/URLVideoPlayer.vue';
export default {
  name: 'FillBox',
  props: {
    rate: { type: Number, default: 1 },
    ignoreFill: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    src: { type: String, default: '' },
    poster: { type: String, default: '' },
    type: { type: String, default: 'image' }
  },
  render(h) {
    return h(
      'div',
      {
        class: {
          'ua-fill-box': true,
          'ua-fill-box--fill': !this.ignoreFill,
          'ua-fill-box--transparent': this.transparent,
          'ua-fill-box--dark': this.type === 'video',
          ['ua-fill-box--' + this.type]: true
        },
        style: {
          paddingBottom: this.rate * 100 + '%'
        }
      },
      this.src
        ? [
            h(
              'div',
              {
                style: {
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  right: '0px',
                  bottom: '0px'
                }
              },
              [
                this.type === 'image'
                  ? h('img', {
                      domProps: { src: this.src },
                      style: { width: '100%', height: '100%', 'object-fit': 'contain' }
                    })
                  : this.type === 'urlVideo'
                  ? h(URLVideo, {
                      style: { width: '100%', height: '100%', backgroundColor: '#000000' },
                      props: {
                        videoSrc: this.src
                      }
                    })
                  : h(CCVideo, {
                      style: { width: '100%', height: '100%' },
                      props: {
                        video: this.src,
                        autoPlay: true,
                        captureImg: this.poster,
                        loop: true,
                        ccVideoOptions: {
                          autoStart: true,
                          realAutoPlay: true,
                          objectFit: 'contain',
                          showFullScreenBtn: false,
                          allowFullScreen: false,
                          rate_allow_change: false,
                          showRateBtn: false
                        }
                      }
                    })
              ]
            )
          ]
        : this.$slots.default
    );
  }
};
</script>

<style lang="scss">
.ua-fill-box {
  width: 100%;
  position: relative;
  height: 0px;
  background: #fff;
  padding-bottom: 100%;
  overflow: hidden;
  &--fill {
    background: #eee;
  }
  &--transparent {
    background: transparent;
  }
  &--dark {
    background: #14141e;
  }
}
</style>
